import type { PropertyResolvedCountRecord } from '../models/element-property.model';
import type { OneOfElements } from '../models/project.model';
import {
  getElementPropertiesByCategorySource,
  getElementPropertyResolvedCountRecord,
} from './element-property.helpers';

/**
 * Resolved counts for every category-sourced property on the element (recipe matching / UI).
 */
export const getCategoryPropertyValueRecord = (
  element: OneOfElements,
): PropertyResolvedCountRecord =>
  getElementPropertyResolvedCountRecord(
    getElementPropertiesByCategorySource(element),
  );
